import mojs from '@mojs/core/dist/mo.umd.js';

class Animate {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-animate]',
			delay: 0,
			duration: 400,
			groupedDelay: 100
		}, config);

		this.$scope = $(this.config.scope);
		this.groups = {};
		this.yElements = [];

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.observer = new IntersectionObserver((entries) => {
			let affectedGroups = new Set();

			entries.forEach(entry => {
				let $scope = $(entry.target);
				$scope.data('in-viewport', entry.isIntersecting);

				if (!entry.isIntersecting) return;
				if ($scope.data('is-animated') === true) return;

				let groupName = $scope.data('animate-group');
				if (groupName) {
					affectedGroups.add(groupName);
				} else {
					$scope.data('is-animated', true);
					this.animate($scope);
					this.observer.unobserve(entry.target);
				}
			});

			affectedGroups.forEach(groupName => this.animateGroup(groupName));
		});

		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			let groupName = $scope.data('animate-group');

			if (groupName) {
				if (!this.groups[groupName]) {
					this.groups[groupName] = [];
				}
				this.groups[groupName].push($scope);
				this.setInitialState($scope);
			} else {
				this.setAnimation($scope);
			}

			if ($scope.data('animate-y-only') !== undefined) {
				this.yElements.push($scope);
			} else {
				this.observer.observe(scope);
			}
		});

		this.initYObservers();
	}

	initYObservers() {
		if (this.yElements.length === 0) return;

		let check = () => {
			let affectedGroups = new Set();

			this.yElements.forEach($scope => {
				if ($scope.data('is-animated') === true) return;

				let elementTop = $scope.offset().top;
				let elementBottom = elementTop + $scope.outerHeight();
				let viewportTop = $(window).scrollTop();
				let viewportBottom = viewportTop + $(window).height();
				let inViewport = elementBottom > viewportTop && elementTop < viewportBottom;

				$scope.data('in-viewport', inViewport);

				if (!inViewport) return;

				let groupName = $scope.data('animate-group');
				if (groupName) {
					affectedGroups.add(groupName);
				} else {
					$scope.data('is-animated', true);
					this.animate($scope);
				}
			});

			affectedGroups.forEach(groupName => this.animateGroup(groupName));
		};

		check();
		$(window).on('scroll', check);
	}

	animateGroup(groupName) {
		let members = this.groups[groupName];
		if (!members) return;

		let toAnimate = members.filter($el => {
			return $el.data('is-animated') !== true && $el.data('in-viewport') === true;
		}).sort(($a, $b) => {
			let prioA = $a.data('prio');
			let prioB = $b.data('prio');
			prioA = prioA === 'first' ? -Infinity : prioA === 'last' ? Infinity : (prioA || 0);
			prioB = prioB === 'first' ? -Infinity : prioB === 'last' ? Infinity : (prioB || 0);
			return prioA - prioB;
		});

		if (toAnimate.length === 0) return;

		let cumulativeDelay = 0;
		toAnimate.forEach(($el, index) => {
			if (index > 0) {
				cumulativeDelay += $el.data('grouped-delay') ?? this.config.groupedDelay;
			}
			let delay = cumulativeDelay;
			$el.data('is-animated', true);
			this.observer.unobserve($el[0]);

			this.setAnimation($el);

			if (delay > 0) {
				setTimeout(() => this.animate($el), delay);
			} else {
				this.animate($el);
			}
		});
	}

	setInitialState($scope) {
		let y = this.getOffsetY($scope);
		let opacity = $scope.data('opacity');
		let css = {};

		if (y) css.transform = `translateY(${y}px)`;
		if (opacity) css.opacity = Object.keys(opacity)[0];

		$scope.css(css);
	}

	setAnimation($scope) {
		let settings = Object.assign({
			el: $scope[0],
			duration: this.config.duration,
			easing: 'ease.out',
			delay: this.config.delay
		}, $scope.data());

		delete settings.animate;
		delete settings.animateGroup;
		delete settings.prio;
		delete settings.groupedDelay;
		delete settings.isAnimated;
		delete settings.timeline;
		delete settings.animation;
		delete settings.inViewport;
		delete settings.animateYOnly;

		let animation = new mojs.Html(settings);
		$scope.data('animation', animation);
	}

	animate($scope) {
		$scope.data('animation').play();
	}

	getOffsetY($scope) {
		let data = $scope.data('y');
		let y = 0
		if (data) {
			y = Object.keys(data)[0];
		}
		return y;
	}

}

export default Animate;